import api from './client';
import type { ApiResponse, AdminUsersResponse, AdminAnalyticsResponse, SupportTicketResponse } from '../../types/api';
import type { User } from '../../types';

export const getAllUsers = async (): Promise<AdminUsersResponse> => {
  const response = await api.get<any, AdminUsersResponse>('/api/admin/users');
  return response;
};

export const deleteUser = async (userId: string): Promise<ApiResponse> => {
  const response = await api.delete<any, ApiResponse>(`/api/admin/users/${userId}`);
  return response;
};

export const updateUser = async (userId: string, userData: Partial<User>): Promise<ApiResponse> => {
  const response = await api.put<any, ApiResponse>(`/api/admin/users/${userId}`, userData);
  return response;
};

export const getAdminAnalytics = async (startDate: string, endDate: string): Promise<AdminAnalyticsResponse> => {
  const response = await api.get<any, AdminAnalyticsResponse>('/api/admin/analytics', {
    params: { startDate, endDate }
  });
  return response;
};

export const getSupportTickets = async (): Promise<SupportTicketResponse> => {
  const response = await api.get<any, SupportTicketResponse>('/api/admin/support-tickets');
  return response;
};

export const updateSupportTicket = async (ticketId: string, status: string): Promise<ApiResponse> => {
  const response = await api.put<any, ApiResponse>(`/api/admin/support-tickets/${ticketId}`, { status });
  return response;
};